import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import './style.css';
import Swal from "sweetalert2";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";




const Box = styled.div`
  width: 100vw; 

`;

const DivMaster = styled.div`
  height: 100%; 
  width: 98%; 
  flex: 1;
  padding: 10px;
  box-sizing: border-box;
  margin: 0px;
  gap: 10px;
  background: #f7f7f8; 
  border-radius: 10px; 
  transition: transform 0.1s, background 0.3s;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: nowrap; /* Impede quebra de linha */
  overflow-x: auto; /* Habilita scroll horizontal */
  white-space: nowrap; /* Impede que os itens quebrem para a próxima linha */
  border: 1px solid #ccc;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  h2 {
    text-align: start;
    color: #3a3f42;
  }
`;
const DivBox = styled.div`

  box-sizing: border-box;
  margin: 5px;
  display: flex;
  gap: 10px
`;
const DivCabecario = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between; 
  width: 98%;
  margin: 5px;
  display: flex;
  gap: 10px
`;

const ContainerColuna = styled.div`
  display: flex;
  align-items: flex-start; 
  justify-content: flex-start; /* Alinha à esquerda para crescimento horizontal */
  flex-wrap: nowrap; /* Evita quebra de linha, permite crescimento horizontal */
  padding: 10px; 
  gap: 10px; 
  background-color: transparent;
  width: 100%;
  height: auto;
  overflow-x: auto; /* Habilita rolagem horizontal */
  white-space: nowrap; /* Impede que o conteúdo quebre para a próxima linha */

`;
const Div = styled.div`
  width: 300px;
  height: 100%; // era 200px;
  display: flex;
  flex-direction: column;

  padding: 10px;

  background-color: #f4f4f5;
  border-radius: 10px;
  border: 1px solid #ccc;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  background: rgba(255, 255, 255, 0.1);
  transition: transform 0.2s, background 0.3s;
  flex-shrink: 0; /* Garante que os itens não encolham */
  
  &:hover {

    box-shadow: 0 4px 6px gray;
  }

`;
const Divdata = styled.div`

  display: flex;
  flex-direction: row;
  justify-content: flex-end; /* Alinha o botão ao final */
  align-items: flex-start; /* Mantém o botão no início horizontal */
  width: 100%;
  margin-top: auto; /* Empurra o botão para o final da div */
`;


const Button = styled.button`
  width: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 5px ;
  cursor: pointer;
  border: none;
  background-color: f4f4f5;
  color: #3a3f42;
  font-size: 20px;
  gap: 5px;
  margin-top: 10px;
  transition: transform 0.3s;
  border: 1px solid #ccc;
  border-radius: 10px;
`;

const ButtonNew = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 5px ;
  cursor: pointer;
  border: none;
  background-color: transparent;
  color: #3a3f42;
  font-size: 20px;
  gap: 5px;

  transition: transform 0.3s;

`;

const P = styled.p`
  font-size: 19px;
  color: #3a3f42;
  overflow-wrap: break-word; /* Quebra palavras longas */
  white-space: normal; /* Permite que o texto quebre em várias linhas */
  height: 110px;
  overflow: hidden;
`;

const Input = styled.input`
  width: 450px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 10px; 
  height: 27px;
  font-size: 20px;
  height: 36px;
  background-color: #f4f4f5;
  color: #3a3f42;
  margin-top: 10px;
`;

const Div2 = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: 7px 0px 10px 20px;
  gap: 5px;
  p {
    margin-right: 5px;
    color: #575757;
  }
`;

const ButtonExportar = styled.td`
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  background-color: #ccc;
  color: white;
  border-radius: 5px;
  width: 50px;
  text-align: center;
  align-items: center;
  height: 20px;
`;


const Grid = ({ setVerQuadro, todosQuadros, todosCartoes }) => {


  //------------------------------------------CAMPO DE PESQUISA-------------------------------------------------------//

  //states do pesquisar
  const [searchTerm, setSearchTerm] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [filtroQuadro, setFiltroQuadro] = useState(todosQuadros);



  const handleSearch = async (term) => {
    setIsLoading(true);

    try {
      const filtered = todosQuadros.filter((user) => {
        const columnsToSearch = [
          'TITULO_QUADRO',
        ];

        // Verifica se algum dos valores nas colunas contém o termo de pesquisa
        return columnsToSearch.some((column) => {
          const columnValue = user[column] ? user[column].toLowerCase() : '';
          return columnValue.includes(term.toLowerCase());
        });
      });
      setFiltroQuadro(filtered);
    } catch (error) {
      console.error(error);
    }

    setIsLoading(false);
  };
  useEffect(() => {
    handleSearch(searchTerm);

  }, [searchTerm, todosQuadros]);

  //-------------------------------------------GERADOR DE PDF------------------------------------------------------//

  const formatarData = (data) => {
    if (!data) return "—";
    const d = new Date(data);
    const dia = String(d.getDate()).padStart(2, '0');
    const mes = String(d.getMonth() + 1).padStart(2, '0');
    const ano = d.getFullYear();
    return `${dia}/${mes}/${ano}`;
  };

  const exportToPDF = () => {
    const opcoesSituacao = {
      AF: "A Fazer",
      PR: "Programado",
      AN: "Em Andamento",
      VA: "Em Validação",
      PA: "Pausado",
      CO: "Concluído",
      CA: "Cancelado",
      AR: "Arquivado",
    };




    const doc = new jsPDF({ orientation: "landscape" });

    doc.setFontSize(14);
    doc.text("Relatório de Quadros e Cartões", 14, 10);

    let startY = 20;

    todosQuadros.forEach((quadro) => {
      autoTable(doc, {
        head: [["Título", "Descrição", "Nome"]],
        body: [[
          quadro.TITULO_QUADRO || "—",
          quadro.DESCRICAO_QUADRO || "—",
          quadro.NOME || "—",
        ]],
        startY,
        styles: { fillColor: [200, 200, 200] },
      });

      startY = doc.lastAutoTable.finalY + 2;

      const cardsDoQuadro = todosCartoes.filter(c => c.ID_QUADRO === quadro.ID_QUADRO);

      if (cardsDoQuadro.length > 0) {
        const cardsData = cardsDoQuadro.map((c, i) => [
          i + 1,
          c.TITULO_CARTAO || "—",
          c.DESCRICAO_CARTAO || "—",
          opcoesSituacao[c.SITUACAO] || c.SITUACAO || "-",
          formatarData(c.DATA_CRIACAO),
          formatarData(c.DATA_CONCLUSAO),
          c.NOME_CRIADOR || "—",
          c.NOME_RESPONSAVEL || "—",
        ]);

        autoTable(doc, {
          head: [["#", "Título", "Descrição", "Situação", "Criado", "Conclusão", "Criador", "Responsável"]],
          body: cardsData,
          startY,
        });

        startY = doc.lastAutoTable.finalY + 10;
      } else {
        doc.setFontSize(12);
        doc.text("Nenhum cartão neste quadro.", 14, startY + 5);
        startY += 15;
      }
    });

    // Resumo por status
    const statusContagem = {};
    todosCartoes.forEach(card => {
      const status = card.SITUACAO || "Não definido";
      statusContagem[status] = (statusContagem[status] || 0) + 1;
    });

    doc.setFontSize(12);
    doc.text(`Total de quadros: ${todosQuadros.length}`, 14, startY);
    doc.text("Resumo por status:", 14, startY + 8);

    let y = startY + 16;
    Object.entries(statusContagem).forEach(([status, count]) => {
      const statusLegivel = opcoesSituacao[status] || status;
      doc.text(`${statusLegivel}: ${count}`, 14, y);
      y += 7;
    });

    doc.text(`Total de cartões: ${todosCartoes.length}`, 14, y + 5);
    window.open(doc.output('bloburl'), '_blank');
  };


  //------------------------------------------GERADOR DE EXCEL-------------------------------------------------------//

  const exportToExcel = () => {

    let data = [];

    todosQuadros.forEach((quadro) => {
      data.push({
        "Título do Quadro": quadro.TITULO_QUADRO || "—",
        "Descrição do Quadro": quadro.DESCRICAO_QUADRO || "—",
        "Nome do Criador": quadro.NOMECRIADOR || "—",
        "Login do Criador": quadro.LOGINCRIADOR || "—",
        "Título do Cartão": "",
        "Descrição do Cartão": "",
        "Situação": "",
        "Criado em": "",
        "Concluído em": "",
        "Criador do Cartão": "",
        "Responsável": "",
      });

      const cardsDoQuadro = todosCartoes.filter(c => c.ID_QUADRO === quadro.ID_QUADRO);

      if (cardsDoQuadro.length > 0) {
        cardsDoQuadro.forEach((c) => {
          data.push({
            "Título do Quadro": "",
            "Descrição do Quadro": "",
            "Nome do Criador": "",
            "Login do Criador": "",
            "Título do Cartão": c.TITULO_CARTAO || "—",
            "Descrição do Cartão": c.DESCRICAO_CARTAO || "—",
            "Situação": c.SITUACAO_LEGIVEL || c.SITUACAO || "—",
            "Criado em": formatarData(c.DATA_CRIACAO) || "—",
            "Concluído em": formatarData(c.DATA_CONCLUSAO) || "—",
            "Criador do Cartão": c.NOME_CRIADOR || "—",
            "Responsável": c.NOME_RESPONSAVEL || "—",
          });
        });
      } else {
        data.push({
          "Título do Cartão": "Nenhum cartão neste quadro",
        });
      }
    });

    // Resumo por situação
    const statusContagem = {};
    todosCartoes.forEach(c => {
      const status = c.SITUACAO_LEGIVEL || c.SITUACAO || "Não definido";
      statusContagem[status] = (statusContagem[status] || 0) + 1;
    });

    data.push({});
    data.push({ "Título do Cartão": "Resumo por Situação:" });

    Object.entries(statusContagem).forEach(([status, count]) => {
      data.push({ "Título do Cartão": `${status}:`, "Descrição do Cartão": count });
    });

    data.push({});
    data.push({ "Título do Cartão": "Total de cartões:", "Descrição do Cartão": todosCartoes.length });
    data.push({ "Título do Cartão": "Total de quadros:", "Descrição do Cartão": todosQuadros.length });

    const worksheet = XLSX.utils.json_to_sheet(data, { skipHeader: false });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Relatório");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "relatorio_quadros_com_cartoes.xlsx");
  };




  //------------------------------------------VER O QUADRO-------------------------------------------------------//

  const showPopUp2 = (titulo) => {
    return new Promise((resolve) => {
      Swal.fire({
        title: `Gostaria de visualizar o quadro: "${titulo}" ?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        customClass: {
          container: 'custom-swal-container', // Estiliza o container principal
          title: 'custom-swal-title', // Estiliza o título
          confirmButton: 'custom-swal-confirm-button', // Estiliza o botão de confirmação
          cancelButton: 'custom-swal-cancel-button', // Estiliza o botão de cancelamento
          popup: 'custom-swal-popup', // Estiliza o popup
          icon: 'custom-swal-icon' // Estiliza o ícone
        },
      }).then((result) => {
        resolve(result.value); // Resolve a Promise com o valor result.value
      });
    });
  };

  const handleEdit = async (quadro) => {
    try {
      const userConfirmed = await showPopUp2(quadro.TITULO_QUADRO); // Passa o título do quadro
      if (!userConfirmed) {
        return; // Se o usuário não confirmar, interrompe a execução
      }


      setVerQuadro(quadro); // Continua se o usuário confirmar
    } catch (error) {
      console.error(error);
    }
  };

  //-------------------------------------------------------------------------------------------------//

  return (
    <div>

      <ContainerColuna>
        <Box >

          <DivMaster className='scroll'>
            <DivCabecario>
              <h2>Todos os quadros criados:</h2>

              <DivBox>
                <Input
                  type="text"
                  placeholder="Pesquisar nome do quadro..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </DivBox>

              <Div2>

                <p>Exportar: </p>
                <ButtonExportar onClick={exportToPDF}>PDF</ButtonExportar>
                <ButtonExportar onClick={exportToExcel}>Excel</ButtonExportar>

              </Div2>

            </DivCabecario>

            <DivBox>
              {filtroQuadro
                .map((quadro) => {
                  return (
                    <Div key={quadro.ID_QUADRO} onClick={() => handleEdit(quadro)} type="button">
                      <P>{quadro.TITULO_QUADRO}</P>

                      <div>
                        <p>{quadro.NOMECRIADOR}</p>
                        <p>{quadro.DESC_DEPARTAMENTO}</p>
                      </div>
                    </Div>
                  );
                })
              }
            </DivBox>



          </DivMaster>

        </Box>
      </ContainerColuna>

    </div >

  );
};

export default Grid;
